export const setLocalStorage = (key, value) => {
    if (typeof window !== 'undefined') {
        try {
            localStorage.setItem(key, JSON.stringify(value));
        } catch (error) {
            console.error(`Error setting localStorage item ${key}:`, error);
        }
    }
}

export const getLocalStorage = (key, defaultValue = null) => {
    if (typeof window !== 'undefined') {
        try {
            const item = localStorage.getItem(key);
            return item ? JSON.parse(item) : defaultValue;
        } catch (error) {
            console.error(`Error getting localStorage item ${key}:`, error);
            return defaultValue;
        }
    }
    return defaultValue;
}

export const removeLocalStorage = (key) => {
    if (typeof window !== 'undefined') {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error(`Error removing localStorage item ${key}:`, error);
        }
    }
}

export const clearLocalStorage = () => {
    if (typeof window !== 'undefined') {
        try {
            localStorage.clear();
        } catch (error) {
            console.error('Error clearing localStorage:', error);
        }
    }
}

export const setSessionStorage = (key, value) => {
    if (typeof window !== 'undefined') {
        try {
            sessionStorage.setItem(key, JSON.stringify(value));
        }
        catch (error) {
            console.error(`Error setting sessionStorage item ${key}:`, error);
        }
    }
}

export const getSessionStorage = (key, defaultValue = null) => {
    if (typeof window !== 'undefined') {
        try {
            const item = sessionStorage.getItem(key);
            return item ? JSON.parse(item) : defaultValue;
        } catch (error) {
            console.error(`Error getting sessionStorage item ${key}:`, error);
            return defaultValue;
        }
    }
    return defaultValue;
}

export const removeSessionStorage = (key) => {
    if (typeof window !== 'undefined') {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            console.error(`Error removing sessionStorage item ${key}:`, error);
        }
    }
}

export const clearSessionStorage = () => {
    if (typeof window !== 'undefined') {
        try {
            sessionStorage.clear();
        } catch (error) {
            console.error('Error clearing sessionStorage:', error);
        }
    }
}

export const getCookie = (name) => {
    if (typeof document !== 'undefined') {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) {
            return parts.pop().split(';').shift();
        }
    }
    return null;
}

export const setCookie = (name, value, days = 1) => {
    if (typeof document !== 'undefined') {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        document.cookie = `${name}=${value};expires=${date.toUTCString()};path=/`;
    }
}

export const removeCookie = (name) => {
    if (typeof document !== 'undefined') {
        document.cookie = `${name}=; Max-Age=-1`;
    }
}

export const clearCookie = () => {
    if (typeof document !== 'undefined') {
        document.cookie.split(';').forEach(cookie => {
            document.cookie = cookie.replace(/^ +/, '').replace(/=.*/, `=;expires=${new Date().toUTCString()};path=/`);
        });
    }
}

export const clearAllStorage = () => {
    clearLocalStorage();
    clearSessionStorage();
    clearCookie();
}



